<div class="px-2" *ngIf="!isOpened">
  <app-custom-table [showExport]="true" [showRecover]="true" [headers]="generalHeader.columns" [data]="generalData"
    [previousFilters]="filters" [filterPersistentKey]="url" [orderTypeId]="orderTypeId" [listOrderType]="listOrderType"
    (onRecoverData)="getAllEquipmentAvailabilityWithPagination()" (onPageChange)="onPageChange($event)"
    (onFilterChange)="onFilterChange($event)" (onExport)="onExport()" (orderTypeEmit)="onOrderTypeChange($event)">
  </app-custom-table>
</div>

<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>